"use strict";

var _toConsumableArray = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.toQueryString = function (obj) {
  var parts = Object.keys(obj).reduce(function (accumulator, key) {
    return [].concat(_toConsumableArray(accumulator), ["".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key]))]);
  }, []);
  return parts.join('&');
};

var urlParamRegex = /{[^}]+}/;

exports.solveURLParams = function (url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (Object.keys(params).length === 0) {
    if (url.match(urlParamRegex) !== null) {
      throw new Error('URL is not completely solved');
    }

    return url;
  }

  var solvedURL = Object.keys(params).reduce(function (accumulator, key) {
    return accumulator.replace("{".concat(key, "}"), params[key]);
  }, url);

  if (solvedURL.match(urlParamRegex) !== null) {
    throw new Error('URL is not completely solved');
  }

  return encodeURI(solvedURL);
};